import { Dropdown } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslate } from '@tolgee/react';
import { useEffect, useRef, useState } from 'react';
import {
  setConversationAttributes,
  setLocationUsers,
  updateConversationAttributesLocaly
} from '../../../redux/slices/communication';
import IsLoadingIndicator from '../../isLoadingIndicator';
import { useClickAway } from 'react-use';
import { COMMUNICATION_ENABLE_ASSIGNMENTS } from '../constants';
import FeaturesToolTip from '../../featuresToolTip';

export function UsersLogs() {
  const {
    data: { locationsUsers }
  } = useSelector((state) => state.communication);

  const { t } = useTranslate();
  const {
    data: { activeConversation }
  } = useSelector((state) => state.communication);
  const [assignedUser, setAssignedUser] = useState(
    activeConversation?.assigned_to_user
  );
  useEffect(() => {
    setAssignedUser(activeConversation?.assigned_to_user);
  }, [activeConversation?.assigned_to_user]);

  const [showDropdown, setShowDropdown] = useState(false);
  const assignedToRef = useRef(null);
  useClickAway(assignedToRef, () => {
    setShowDropdown(false);
  });
  const dispatch = useDispatch();

  const getUsersForLocation = (locationUuid) => {
    if (!locationsUsers?.[locationUuid])
      dispatch(setLocationUsers(locationUuid));
  };
  const setAssignedUserDetails = (user) => {
    setAssignedUser({
      name: user?.first_name + ' ' + user?.last_name,
      uuid: user.uuid
    });
    dispatch(
      updateConversationAttributesLocaly(activeConversation.uuid, {
        assigned_to_user: {
          uuid: user.uuid,
          name: user?.first_name + ' ' + user?.last_name
        }
      })
    );
    dispatch(
      setConversationAttributes(activeConversation.uuid, {
        assigned_to: user.uuid
      })
    );
  };
  useEffect(() => {
    setAssignedUser(activeConversation?.assigned_to_user);
  }, [activeConversation]);
  console.log(locationsUsers);
  const { userData } = useSelector((state) => state.userDetails);

  return (
    <div className="card m-2 p-4 shadow w-100">
      <b className="text-muted m-0 mb-2 p-0 fs-6 fw-bold">
        {t('communication.general_info.team')}
      </b>
      <div className="mt-1" />
      <p className="p-1 fw-bold text-muted">
        {t('communication.general_info.assigned_to')}
      </p>
      <FeaturesToolTip
        featureIsActive={
          userData?.feature_list_for_user[COMMUNICATION_ENABLE_ASSIGNMENTS]
        }
        feature={COMMUNICATION_ENABLE_ASSIGNMENTS}
        InnerComponent={() => (
          <div className="d-flex align-items-center">
            <Dropdown
              className={'w-100 text-start'}
              show={showDropdown}
              ref={assignedToRef}
              onClick={() => {
                if (
                  userData?.feature_list_for_user[
                    COMMUNICATION_ENABLE_ASSIGNMENTS
                  ]
                ) {
                  setShowDropdown(!showDropdown);
                  getUsersForLocation(activeConversation?.location_uuid);
                }
              }}
            >
              <Dropdown.Toggle
                size="sm"
                variant="none"
                className="w-100 text-start"
              >
                {assignedUser ? (
                  <>
                    <i className="fa-duotone fa-user mx-1"></i>
                    <span className="px-1">{t(assignedUser?.name)}</span>
                  </>
                ) : (
                  <>
                    <span className="px-2">
                      {t('communication.general_info.no_assigned_user')}
                    </span>
                  </>
                )}
              </Dropdown.Toggle>
              <Dropdown.Menu className="w-100 text-start">
                {!locationsUsers?.[activeConversation?.location_uuid] && (
                  <div className="w-100 h-100 d-flex align-items-center justify-content-center">
                    <IsLoadingIndicator />
                  </div>
                )}
                {locationsUsers?.[activeConversation?.location_uuid]?.map(
                  (item, index) => (
                    <Dropdown.Item
                      onClick={() => setAssignedUserDetails(item)}
                      key={index}
                      value={Number(index)}
                      active={item.uuid === assignedUser?.uuid}
                    >
                      <i className="fa-duotone fa-user mx-1"></i>
                      <span className="px-1">
                        {item?.first_name + ' ' + item?.last_name}
                      </span>
                    </Dropdown.Item>
                  )
                )}
              </Dropdown.Menu>
            </Dropdown>
            {assignedUser && (
              <div
                onClick={() => {
                  setAssignedUser(null);
                  dispatch(
                    setConversationAttributes(activeConversation.uuid, {
                      assigned_to: null
                    })
                  );
                  dispatch(
                    updateConversationAttributesLocaly(
                      activeConversation.uuid,
                      {
                        assigned_to_user: null
                      }
                    )
                  );
                }}
                className="cursor-pointer"
              >
                <i className="fa-duotone fa-times mx-1"></i>
              </div>
            )}
          </div>
        )}
      />
      {activeConversation?.participants_to_conversation?.length > 0 && (
        <>
          <p className="p-1 fw-bold text-muted">
            {t('communication.general_info.active_users')}
          </p>
          <div>
            {activeConversation?.participants_to_conversation?.map((p) => (
              <div className="d-flex align-items-center px-4" key={p.uuid}>
                <i className="fa-duotone fa-user mx-2"></i>
                <span>{p?.name}</span>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
